import { useQueryWithUserId } from '@northladder/services';

import { CUSTOMER_SERVICE_API } from '../customerServiceClient';

/**
 * This is to track the appraisal info by code query key in react query cache.
 */
const GET_APPRAISAL_DETAILS_BY_ID = 'get-appraisal-details-by-id-key';

/**
 * `useAppraisalDetailsQuery` handles the API call to to get the details
 * of the appraisal by appraisal id.
 */
export const useAppraisalDetailsQuery = (appraisalId: string) => {
  const { data, error, isError, isPending, refetch } = useQueryWithUserId({
    queryKey: [GET_APPRAISAL_DETAILS_BY_ID, appraisalId],
    enabled: Boolean(appraisalId),
    queryFn: () => CUSTOMER_SERVICE_API.fetchAppraisalDetails(appraisalId),
  });
  return {
    data,
    error,
    isError,
    isPending,
    refetch,
  };
};
